import React, { useState } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import { Routes, Route } from 'react-router';
import { registerUserRequest } from '../services/user.api.service';
import VerificationEmailSent from '../components/verification_email_sent/verification_email_sent';
import ExpiredEmail from '../components/expired_email/expired_email';
import GetStarted from '../components/get_started/get_started';
import DefaultRegisterForm from '../components/default_register_form/default_register_form';
import { IsSignedIn, PackageShortName, PaymentPage, ReturnTo, Text1, Text2 } from '../types/membership_flow.types';

interface Props {
  text1: Text1;
  text2: Text2;
  packageShortName: PackageShortName;
  authToken: string;
  paymentPage: PaymentPage;
  isSignedIn: IsSignedIn;
  returnTo?: ReturnTo;
}

const SignupApp: React.FC<Props> = ({
  text1,
  text2,
  packageShortName,
  authToken,
  paymentPage,
  returnTo = '',
  isSignedIn,
}) => {
  // When going to Expired url we want the email from the url
  const emailFromUrl = useQueryParam('email', StringParam);
  const [emailRecipient, setEmailRecipient] = useState(emailFromUrl[0] || '');

  // Method to be executed in ExpiredEmail and VerificationEmailSent components
  const postRegistrationRequest = () =>
    registerUserRequest({
      email: emailRecipient,
      packageShortName,
      paymentPage,
      returnTo,
    });

  return (
    <div data-testid='default-registration'>
      <Routes>
        {/* Registration before email verification */}
        <Route
          path='expired'
          element={
            <ExpiredEmail
              emailRecipient={emailRecipient}
              registerUserRequest={postRegistrationRequest}
            />
          }
        />
        <Route
          path='verification-sent'
          element={
            <VerificationEmailSent
              packageShortName={packageShortName}
              emailRecipient={emailRecipient}
              registerUserRequest={postRegistrationRequest}
              mailTo='registration@devex.com'
            />
          }
        />
        {/* GetStarted is only rendered when AAs go to /regster/PRO or /register/CA */}
        <Route
          path='get-started'
          element={
            <GetStarted
              packageShortName={packageShortName}
              paymentPage={paymentPage}
              returnTo={returnTo}
              text1={text1}
              text2={text2}
            />
          }
        />
        <Route
          path='/'
          element={
            <DefaultRegisterForm
              text1={text1}
              text2={text2}
              packageShortName={packageShortName}
              paymentPage={paymentPage}
              authToken={authToken}
              returnTo={returnTo}
              isSignedIn={isSignedIn}
              setEmailRecipient={setEmailRecipient}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default SignupApp;
